import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const SportsmanContext = createContext<{ params?: Routing.SportsmanParams }>({})

export { SportsmanContext }